import React, {PropTypes} from "react";
import {connect} from "react-redux";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import ToolTip from "react-bootstrap/lib/Tooltip";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Modal from "react-bootstrap/lib/Modal";
import LeaveHistory from "../LeaveTeamWeekly";
import * as actions from "../../../redux/actions/leaveActions";

class LeaveTeam extends React.Component {

  constructor() {
    super();
    this.state = {showDialog: false, row: null, approve: false, comment: null}
    this.close = this.close.bind(this);
  }

  close() {
    this.setState({showDialog: false});
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell === "") {
      return 'NA';
    }
    return cell;
  }

  checkDate(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == "") {
      return 'NA';
    }
    return new Date(cell).toString().substr(0,16);
  }

  check(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == "") {
      return 'NA';
    }
    return cell.substr(0, 10);
  }

  componentDidMount() {
    this.props.changeBanner("Team Leave");
    this.props.dispatch(actions.getTeamLeave());
  }

  render() {
    return (
      <div>
        <h2 style={{marginTop: 5}}>Team Leave Applications</h2>
        <div style={{
          paddingBottom: '5px',
          borderLeftStyle: 'solid',
          borderLeftColor: 'rgb(92, 184, 92)',
          borderWidth: '1px'
        }}>
          <BootstrapTable height="350"
                          exportCSV={true}
                          search={true}
                          data={this.props.team.team} striped={false} hover={true} condensed={true}>
            <TableHead dataSort={true}
                       hidden={true}
                       dataFormat={this.returnNull}
                       isKey={true} dataField="applicantId"></TableHead>
            <TableHead
              width={90}
              dataFormat={(cell, row)=> {
                console.log(row);
                if (row.actionable)
                  return <a  >
                    <OverlayTrigger placement="top" overlay={<ToolTip id="tooltip">Approve</ToolTip>}>
                      <img onClick={()=> {
                        this.setState({showDialog: true, row: row, approve: true})
                      }}
                           className="hand" style={{cursor: 'hand'}} src="/public/images/success.png"/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<ToolTip id="tooltip">Reject</ToolTip>}>
                      <img onClick={()=> {
                        this.setState({showDialog: true, row: row, approve: false})
                      }
                      } className="hand" style={{cursor: 'hand', paddingLeft: '10px'}} src="/public/images/error.png"/>
                    </OverlayTrigger>

                  </a>;
                else
                  return <a  >
                    <OverlayTrigger placement="top" overlay={<ToolTip id="tooltip">Disabled</ToolTip>}>
                      <img className="hand" style={{cursor: 'hand'}} src="/public/images/success2.png"/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<ToolTip id="tooltip">Disabled</ToolTip>}>
                      <img className="hand" style={{cursor: 'hand', paddingLeft: '10px'}}
                           src="/public/images/error2.png"/>
                    </OverlayTrigger>
                  </a>

              }}
              dataField="empId">Approve<br/>Reject</TableHead>


            <TableHead dataSort={true}
                       width={130}
                       dataField="applicantName">Employee <br/> Name</TableHead>
            <TableHead dataSort={true}
                       width={75}
                       dataField="leaveType" dataFormat={this.checkNull}>Leave <br/>Type</TableHead>

            <TableHead dataSort={true}
                       width={100}
                       dataFormat={this.checkDate}
                       dataField="startDate">Start Date</TableHead>
            <TableHead dataSort={true}
                       width={100}
                       dataField="endDate" dataFormat={this.checkDate}>End Date</TableHead>
            <TableHead dataSort={true}
                       width={100}
                       dataField="applyDate" dataFormat={this.check}>Applied<br/> Date</TableHead>
            <TableHead dataSort={true}
                       width={80}
                       dataFormat={this.checkNull}
                       dataField="totalLeaveTaken">No of <br/>Days</TableHead>
            <TableHead dataField="leaveBalance"
                       width={85}
                       dataFormat={this.checkNull}
                       dataSort={true}>
              Leave <br/> Balance</TableHead>
            <TableHead dataSort={true}
                       width={300}


                       dataField="leaveReason">Leave <br/> Reason</TableHead>


          </BootstrapTable>
          <Modal show={this.state.showDialog}
                 onEntered={()=> {
                   this.setState({comment: null})
                 }}
                 onHide={this.close}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.approve ? "Approve Leave" : "Cancel Leave"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              {this.state.row != null ?

                <div>
                  <p>Employee Name: {this.state.row.applicantName}</p>
                  <p>Leave Type: {this.state.row.leaveType}</p>
                  <p>Start Date: {this.state.row.startDate}</p>
                  <p>End Date: {this.state.row.endDate}</p>
                  <p>No of Days: {this.state.row.totalLeaveTaken}</p>
                  <p>Leave
                    Reason: {this.state.row.leaveReason != null && this.state.row.leaveReason != "" ? this.state.row.leaveReason : 'NA'}</p>
                  <div className="form-group">
                    <label style={{fontSize: '15'}}>Remarks</label>
                    <textarea
                      disabled={false}
                      onChange={(event)=> {
                        this.setState({comment: event.target.value})
                      }}
                      className="form-control" rows="3">
                          </textarea>
                  </div>
                </div>
                : null}
              <hr />
              <button onClick={()=> {
                this.setState({showDialog: false});
                var status = '';
                if (this.state.approve)
                  status = 'approved';
                else
                  status = 'rejected';
                this.props.dispatch(actions.rejectLeave({
                  applicantId: this.state.row.applicantId,
                  leaveRemark: this.state.comment,
                  leaveProcess: status
                }));
              }} className="btn btn-default">{this.state.approve ? "Approve Leave" : "Cancel Leave"}</button>

              <button
                style={{marginLeft: '5%'}}
                className="btn btn-default"
                onClick={()=> {
                  this.setState({showDialog: false})
                }
                }>Cancel
              </button>
            </Modal.Body>
          </Modal>

        </div>
        <LeaveHistory isVertical = {this.props.isVertical}/>
      </div>
    );
  }

}

LeaveTeam.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    team: state.leave[3]
  };

}

export default connect(mapStateToProps)(LeaveTeam);




/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveTeam/LeaveTeam.js
 **/